import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, Checkbox, FormControlLabel } from '@mui/material';
import axios from 'axios';
import { SimecUser } from 'components';
import { LocalizationIds } from 'helpers/Localizations';
import { useIntl } from 'react-intl';
import { useSnackbar } from 'notistack';


interface IProps {
    userId: string
    email: string
    canGoToCustomer: boolean

    onClose: (refreshTable: boolean) => void
}

interface IPartialUser {
    id: string
    email: string
    canGoToCustomer: boolean
}


let CanGoToCustomerEdit = (props: IProps) => {
    let { formatMessage } = useIntl();
    let { enqueueSnackbar } = useSnackbar();

    let [isSaving, setSaving] = useState(false);
    let [userToEdit, setUserToEdit] = useState<IPartialUser>({} as IPartialUser);


    useEffect(() => {
        setUserToEdit({
            ...userToEdit,
            canGoToCustomer: props.canGoToCustomer,
            email: props.email,
            id: props.userId
        });
    }, []);


    let closeAndConfirm = async () => {
        try {
            setSaving(true);

            let request = {
                ...userToEdit
            }

            let res = await axios.post('/api/User/UpdateCanGoToCustomer', request);

            if (res.data.affectedRecords === 1) {
                enqueueSnackbar(formatMessage({ id: LocalizationIds.TicketSaved }), { variant: "success" });
                props.onClose(true);
            }
        } catch (err) { }
        finally {
            setSaving(false);
        }
    }

    return (
        <Dialog
            open={true}
            maxWidth="md"
            fullWidth={true}
            scroll="paper"
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">
               <SimecUser username={props.email} />
            </DialogTitle>
            <DialogContent dividers style={{ paddingTop: 0 }}>
                <Grid container>
                    <Grid item xs={12}>
                        <FormControlLabel
                            label={formatMessage({ id: LocalizationIds.CanGoToCustomer })}
                            name="canGoToCustomer"
                            control={
                                <Checkbox
                                    checked={userToEdit.canGoToCustomer}
                                    onChange={(e, value) => setUserToEdit({ ...userToEdit, canGoToCustomer: value === true ? true : false })}
                                    name="canGoToCustomer"
                                    color="secondary"
                                />
                            }
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => { props.onClose(false) }}
                    color="secondary"
                >
                    {formatMessage({ id: LocalizationIds.Close })}
                </Button>
                <Button
                    onClick={() => closeAndConfirm()}
                    disabled={isSaving === true || userToEdit.id == null || userToEdit.id?.length <= 0}
                    autoFocus
                >
                    {formatMessage({ id: LocalizationIds.Confirm })}

                </Button>
            </DialogActions>
        </Dialog >
    )
}

export default CanGoToCustomerEdit;